import { formatDocDate } from '@/lib/format-date';
import { useMeQuery } from '@/query/auth';

import { CustomTitle } from '@/components/typography';

import './user-info-card.scss';

function UserInfoCard() {
  const { data, isLoading, isError } = useMeQuery();

  if (isLoading) {
    return (
      <div className="user-info-card user-info-card--loading">Loading…</div>
    );
  }
  if (isError || !data) {
    return (
      <div role="alert" className="user-info-card user-info-card--error">
        Couldn't load your profile — try refreshing.
      </div>
    );
  }

  return (
    <div className="user-info-card">
      <CustomTitle level="h2" className="user-info-card__heading">
        Your profile
      </CustomTitle>
      <dl className="user-info-card__list">
        <dt>Email</dt>
        <dd>{data.email}</dd>
        <dt>Role</dt>
        <dd>{data.role}</dd>
        <dt>Status</dt>
        <dd>{data.isActive ? 'Active' : 'Inactive'}</dd>
        <dt>Member since</dt>
        <dd>{formatDocDate(data.createdAt)}</dd>
        <dt>Last login</dt>
        <dd>{formatDocDate(data.lastLoginAt)}</dd>
      </dl>
    </div>
  );
}

export { UserInfoCard };
